
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-8---scalable-components"}}>{`Ex. 8 - Scalable Components`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous souhaitons afficher les films sous forme d'une Card un peu plus élaborée.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Créer un composant `}<MDXTag name="inlineCode" components={components} parentName="li">{`Card`}</MDXTag>{` qui exposera :`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`Card`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`Card.Body`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`Card.Title`}</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`Card.Subtitle`}</MDXTag></MDXTag>
</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`Lorsque le champs de recherche est vide, j'obtiens une liste vide.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-8/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"card"}}>{`Card`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`import styled from 'styled-components'

const Card = styled.div\`
  color: #fff;
  text-shadow: 1px 1px 0 #000;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
\`

Card.Body = styled.div\`
  padding: 10px;
\`

Card.Title = styled.h3\`
  font-size: 1.2em;
  line-height: 1.2em;
  font-weight: 500;
  margin: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
\`
Card.Subtitle = styled.p\`
  font-size: 0.9em;
  margin: 0;
\`

export default Card
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"composition-dune-card"}}>{`Composition d'une Card`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`function MovieCard({ movie }) {
  return (
    <Card
      style={{
        height: 200,
        backgroundImage: movie.backdrop_path
          ? \`url(https://image.tmdb.org/t/p/original/\${movie.backdrop_path})\`
          : null,
      }}
    >
      <Card.Body>
        <Card.Title>{movie.title}</Card.Title>
        <Card.Subtitle>
          {movie.vote_average} ({movie.vote_count} votes)
        </Card.Subtitle>
      </Card.Body>
    </Card>
  )
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  